const state = {
	marketsTitle: '',
	marketsCode: '',
	marketsDesc:'',
	marketsList:[]
}

const getters = {
	marketsTitle: state => {
		let marketsTitle= localStorage.getItem("SIP-marketsTitle");
		if(marketsTitle){
			state.marketsTitle=marketsTitle;
		}
		return state.marketsTitle;
	},
	marketsCode: state => {
		let marketsCode= localStorage.getItem("SIP-marketsCode");
		if(marketsCode){
			state.marketsCode=marketsCode;
		}
		return state.marketsCode;
	},
	marketsDesc: state => {
		let marketsDesc= localStorage.getItem("SIP-marketsDesc");
		if(marketsDesc){
			state.marketsDesc=marketsDesc;
		}
		return state.marketsDesc;
	},
	marketsList: state => {
		return state.marketsList;
	},
}

const actions = {
	marketsTitleHandler(context, payload){
		context.commit('marketsTitleHandler', payload);
	},
	marketsCodeHandler(context, payload){
		context.commit('marketsCodeHandler', payload);
	},
	marketsDescHandler(context, payload){
		context.commit('marketsDescHandler', payload);
	},
	marketsListHandler(context, payload){
		context.commit('marketsListHandler', payload);
	}
}

const mutations = {
	marketsTitleHandler(state, marketsTitle){
		localStorage.setItem("SIP-marketsTitle",marketsTitle);
		state.marketsTitle = marketsTitle;
	},
	marketsCodeHandler(state, marketsCode){
		localStorage.setItem("SIP-marketsCode",marketsCode);
		state.marketsCode = marketsCode;
	},
	marketsDescHandler(state, marketsDesc){
		localStorage.setItem("SIP-marketsDesc",marketsDesc);
		state.marketsDesc = marketsDesc;
	},
	marketsListHandler(state, marketsList){
		state.marketsList = marketsList;
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/markets/index.js